import React, { useEffect } from "react"
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';


const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        minWidth: 80,
        width: "-webkit-fill-available"
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

function FormDialog(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const { op, setOp, title, func, fields } = props

    useEffect(() => {
        setOpen(op)
    }, [op])


    const handleClose = () => {
        setOpen(false);
        setOp(false)
    };

    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    < TextField
                        margin="dense"
                        label="Չափսի կոդ"
                        type="text"
                        fullWidth
                        value={fields.code.value}
                        onChange={(e) => { fields.code.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="Անվանում"
                        type="text"
                        fullWidth
                        value={fields.name.value}
                        onChange={(e) => { fields.name.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="Երկիր"
                        type="text"
                        fullWidth
                        value={fields.country.value}
                        onChange={(e) => { fields.country.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="1"
                        type="text"
                        fullWidth
                        value={fields.option1.value}
                        onChange={(e) => { fields.option1.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="2"
                        type="text"
                        fullWidth
                        value={fields.option2.value}
                        onChange={(e) => { fields.option2.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="3"
                        type="text"
                        fullWidth
                        value={fields.option3.value}
                        onChange={(e) => { fields.option3.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="4"
                        type="text"
                        fullWidth
                        value={fields.option4.value}
                        onChange={(e) => { fields.option4.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="5"
                        type="text"
                        fullWidth
                        value={fields.option5.value}
                        onChange={(e) => { fields.option5.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="6"
                        type="text"
                        fullWidth
                        value={fields.option6.value}
                        onChange={(e) => { fields.option6.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="7"
                        type="text"
                        fullWidth
                        value={fields.option7.value}
                        onChange={(e) => { fields.option7.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="8"
                        type="text"
                        fullWidth
                        value={fields.option8.value}
                        onChange={(e) => { fields.option8.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="9"
                        type="text"
                        fullWidth
                        value={fields.option9.value}
                        onChange={(e) => { fields.option9.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="10"
                        type="text"
                        fullWidth
                        value={fields.option10.value}
                        onChange={(e) => { fields.option10.func(e.target.value) }}
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Չեղարկել
          </Button>
                    <Button onClick={func} color="primary">
                        Հաստատել
          </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default FormDialog